import { createSelector } from 'reselect';
import values from 'lodash/values';
import pick from 'lodash/pick';
import { Id } from '@/types/index';
import { IModels, IModelName, IModelsObject } from '@/models/types';
import { createCachedSelector } from '../utils/selectors';
import { safeGet } from '@/utils/safeImmutable'; 

// FIX: Always use safeGet. This prevents the "e.get is not a function" crash.
export const selectModels = (state: any) => safeGet(state, 'models');

export const selectModelCached = (name: IModelName) =>
  createCachedSelector(
    selectModels,
    (models: IModels) => pick(models, [name]),
    (models: IModels) => {
      const modelData = pick(models, [name]);
      return JSON.stringify(modelData[name] ? Object.keys(modelData[name]) : '');
    }
  );

export const selectModel = (name: IModelName) =>
  createSelector(selectModels, (models: IModels) => pick(models, [name]));

export const findOne = (name: IModelName, id: Id, cached: boolean = false) =>
  createSelector(cached ? selectModelCached(name) : selectModel(name), (model: IModelsObject) => {
    const models = model[name];
    return models && models[id];
  });

export const find = (name: IModelName, ids: Id[], cached: boolean = false) =>
  createSelector(cached ? selectModelCached(name) : selectModel(name), (model: IModelsObject) => {
    if (!model || !model[name]) return [];
    return values(pick(model[name], ids));
  });

export const findAll = (name: IModelName, cached: boolean = false) =>
  createSelector(cached ? selectModelCached(name) : selectModel(name), (model: IModelsObject) => {
    return values(model)[0];
  });

export const findAllValues = (name: IModelName, cached: boolean = false) =>
  createSelector(cached ? selectModelCached(name) : selectModel(name), (model: IModelsObject) => {
    const data = values(model)[0];
    return data ? values(data) : [];
  });